/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesContract" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import { TestSuite } from "TestPlanCommon/Contracts/TestPlan";

export interface ISuitesAwareState extends ITestHubRefreshAwareState {
    suiteState: ISuitesState;
}

export interface TestSuiteWithCount extends TestSuite {
    pointCount?: number;
    totalPointCount?: number;
    testCaseCount?: number;
    totalTestCaseCount?: number;
}

export interface ISuitesState {
    testSuites: TestSuiteWithCount[];

    // map with suite id as key and TestSuiteWithCount as value
    idToTestSuiteMap: Map<number, TestSuiteWithCount>;

    // map with suite id as key and expanded state as value
    idToTreeItemExpandableStateMap: Map<number, boolean>;

    // suite id when the suite name is in edit mode
    editableSuiteId: number;
}

export interface ISuitesTreeFilteredState extends ISuitesState {
    allTestSuites: TestSuiteWithCount[];
    // map with suite id as key and expanded state as value
    testSuiteExpandedStateMap: Map<number, boolean>;
}
